import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 10em 0 5em 0;

	.content-container {
		padding: 2.5em;

		.headline {
			margin: 0 0 1.5rem 0;
			font-size: 2.18em;
			font-weight: 600;
		}
		.paragraph {
			margin: 0 0 0.35em 0;
			line-height: 1.8em;
		}

		.form-container {
			max-width: 500px;

			.form-input {
				margin: 2.8em 0 0 0;
				display: flex;
				align-self: flex-start;
				flex-flow: column nowrap;
			}
			.google-recaptcha {
				margin: 1em 0 1.4em 0;
			}
			.submit-button {
				padding-top: 1em;
				justify-content: flex-start;
			}
		}
	}

	.layout-forms-input {
		.layout-forms-input-wrapper {
			.internal-wrapper {
				.input-body {
					.input {
						text-align: flex-start;
						letter-spacing: 1px;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		.content-container {
			max-width: 100%;
			width: 100%;

			.form-container {
				max-width: 500px;

				.form-input {
					display: flex;

					.place-of-sending {
						font-size: unset;
					}
				}
			}

			.layout-forms-input {
				.layout-forms-input-wrapper {
					.label-wrapper {
						.label-body {
							.layout-forms-input-label {
								font-size: 0.6em;
							}
						}
					}
				}
			}
		}
	}
`;
